import React from 'react';
import QoreIdLivenessCheck from './QoreIdLivenessCheck';
import LivenessCheck from '../components/LivenessCheck';
import { useSelector } from 'react-redux';

const CombinedLivenesssCheck = () => {
    const livenessCheckStatus = useSelector((state) => state.oxygenRetail?.useLivenessCheck);

  return (
    <div>
        {
            livenessCheckStatus === 'qoreId' ?(
                <QoreIdLivenessCheck />
            ):  livenessCheckStatus === 'smileId' ?(
                <LivenessCheck />
            ): null
        }
    </div>
  )
}

export default CombinedLivenesssCheck;